import styles from "./not-found.module.css";
import notFound from "illustrations/not-found.png";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const redirect = () => {
    navigate("/dashboard");
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <img
          className={`${styles.image} mb-24`}
          src={notFound}
          alt="not found"
          data-testid="not-found-image"
        />
        <h1 className={`title-1-variant-low mb-18 ${styles.title}`}>
          {t("not-found.title")}
        </h1>
        <p className={`title-3-variant mb-32 ${styles.description}`}>
          {t("not-found.description")}
        </p>
        <button className="btn btn--primary" onClick={redirect}>
          {t("not-found.cta")}
        </button>
      </div>
    </div>
  );
};

export default NotFound;
